/*
  * All Universal Commonly Used Modals *
  @SelectPractice: Select practice at start
  @Error : Error modal to display errors
  @Snackbar : Snackbar to show messages or errors
  @Loading : Loader spinner
  @Success : To show success Modal
  @Confirm : To show confirmation modal
*/
import { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import SelectPractice from "components/modals/SelectPractice";
import ErrorModel from "components/modals/Error";
import ConfirmModal from "components/modals/Confirm";
import Loading from "components/modals/Loading";
import Snackbar from "components/modals/snackbar";
import SuccessModal from "components/modals/SuccessModal";
import { CLOSE_RESPONSE_MODAL, HIDE_SNACKBAR } from "store/actions/actionTypes";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { getERAReferenceData, getProviderDetails } from "store/actions";

const UniversalModals = () => {
  const { logged_in, selected_practice } = useSelector(({ auth }) => ({
    logged_in: auth.logged_in,
    selected_practice: auth?.authData?.selected_practice,
  }));
  const {
    loading,
    showResponseModal,
    errorMessage,
    showSnackbar,
    snackbarDuration,
  } = useSelector(({ app }) => ({
    loading: app.loading,
    showResponseModal: app.showResponseModal,
    errorMessage: app.errorMessage,
    showSnackbar: app.showSnackbar,
    snackbarDuration: app.snackbarDuration,
  }));
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    if (selected_practice) {
      dispatch(getERAReferenceData());
      dispatch(getProviderDetails());
    }
  }, [selected_practice, dispatch]);

  if (pathname.includes("admin")) return null;

  return (
    <Fragment>
      {logged_in && !selected_practice ? <SelectPractice /> : null}
      {showResponseModal && (
        <ErrorModel
          errorMessage={errorMessage}
          onClose={() => dispatch({ type: CLOSE_RESPONSE_MODAL })}
        />
      )}
      {showSnackbar && (
        <Snackbar
          message={errorMessage}
          duration={snackbarDuration}
          onClose={() => dispatch({ type: HIDE_SNACKBAR })}
        />
      )}
      {loading && <Loading />}
      {false && <ConfirmModal />}
      <SuccessModal />
    </Fragment>
  );
};

export default UniversalModals;
